import React, { useContext } from "react";
import { StateContext } from "../context/stateContext";
import styles from "../styles/hero.module.scss";
import { translations } from "../translate";

const Hero: React.FC<{ isForTrustedDevices?: boolean }> = props => {
  const { languageCode } = useContext(StateContext);
  return (
    <div className={styles["left-pane"]}>
      <h2 className={styles["hero-title"]}>
        {props.isForTrustedDevices ? translations.headingLogin[languageCode] : translations.heading[languageCode]}
      </h2>
      <ul className={styles["hero-list"]}>
        <li className={styles["hero-list-item"]}>
          {props.isForTrustedDevices
            ? translations.reviewClaims[languageCode]
            : translations.ThirdPartyAppDevelopers[languageCode]}
        </li>
        <li className={styles["hero-list-item"]}>
          {props.isForTrustedDevices
            ? translations.getDocuments[languageCode]
            : translations.asCurrentPlanMember[languageCode]}
        </li>
        <li className={styles["hero-list-item"]}>
          {props.isForTrustedDevices
            ? translations.accessYourMember[languageCode]
            : translations.thisDecision[languageCode]}
        </li>
      </ul>
    </div>
  );
};

export default Hero;
